import script from "./detailsHeaderAddress.vue?vue&type=script&lang=js"
export * from "./detailsHeaderAddress.vue?vue&type=script&lang=js"

import "./detailsHeaderAddress.vue?vue&type=style&index=0&id=626f83b8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626f83b8"]])

export default __exports__